import { Outlet } from "react-router-dom";

const StructuralSubDivisionCategories = () => <Outlet />;

export default StructuralSubDivisionCategories;
